module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA1klEQVR4AWMYHIDLsOI/E4fwfyCTNAwD/O7r//M5L/vPLu/zn4GRiTwDYJjHsuc/M58yeQYYxk4H08JeG/6XT7/0/8u33//xAEwDli93+d8+Ofp/bEUFmK/mOO//bCWP/7eEpLBhhAGCHuv+1/Um/f92k/f/rztc/9XC5v9H8hZhA2AKly5z+1/Zlfo/sqwazFd1nP9/lrIn8QZoR84G00KekDD4TEoYwDBvyLT/nDVe/9k7DQhhNAO8Vv7nykn/z95hBJIkzQDe6I7/HI12MAniDRgeAAA/di+l+spCwwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/SS.png
// module id = 1269
// module chunks = 0